/**
 * Asynchronously loads the component
 */
import Loadable from 'react-loadable';

import { StyledSpinnerContainer } from './StyledComponents';

export default Loadable({
  loader: () => import(/* webpackChunkName: "ListingClaimPage.loadable" */ './index'),
  loading: StyledSpinnerContainer,
});
